export class Contract {
  id: number;
  name: string;
  client_org_id: number;
  service_provider_org_id: number;
  billing_method: string | null;
  // The subscription's period (MPN-1530 §4.2). Both null unless the contract
  // bills on a recurring amount; the Monitor page's Current Billing Period panel
  // renders only when both are set.
  billing_amount: number | null;
  billing_frequency: string | null;
  po: string | null;
  contract_url: string | null;
  contract_start_date: string | null;
  contract_end_date: string | null;
  products: readonly string[];
  revenue_cap: number | null;
  max_list_size: number | null;  // contracted maximum; a data point, not enforced (MPN-1950)
  sized_by: string | null;
  list_type: string | null;
  is_active: boolean;
  journey_id: number | null;
  spend_account_id: number | null;
  spend_account_name: string | null;
  spend_account_balance: number | null;
  spend_account_is_active: boolean | null;

  constructor(data: any) {
    this.id = data.id;
    this.name = data.name ?? "";
    this.client_org_id = data.client_org_id;
    this.service_provider_org_id = data.service_provider_org_id;
    this.billing_method = data.billing_method ?? null;
    this.billing_amount =
      data.billing_amount != null ? Number(data.billing_amount) : null;
    this.billing_frequency = data.billing_frequency || null;
    this.po = data.po ?? null;
    this.contract_url = data.contract_url ?? null;
    this.contract_start_date = data.contract_start_date ?? null;
    this.contract_end_date = data.contract_end_date ?? null;
    this.products = data.products ?? [];
    this.revenue_cap = data.revenue_cap ?? null;
    this.max_list_size = data.max_list_size ?? null;
    this.sized_by = data.sized_by ?? null;
    this.list_type = data.list_type ?? null;
    this.is_active = data.is_active ?? true;
    this.journey_id = data.journey_id ?? null;
    this.spend_account_id = data.spend_account_id ?? null;
    this.spend_account_name = data.spend_account_name ?? null;
    this.spend_account_balance =
      data.spend_account_balance != null ? Number(data.spend_account_balance) : null;
    this.spend_account_is_active = data.spend_account_is_active ?? null;
  }
}
